import { GoodsCreateActions as GoodsCreate } from "./GoodsCreate";
import { combineReducers, createStore, Store } from "lib/store/v3";
import { createStoreLogger } from "lib/store/v3/createStoreLogger";

const reducer = combineReducers({ GoodsCreate }, createStoreLogger("GoodsCreate"));

export type GoodsCreateStore = Store<typeof reducer>;

export const { useSelector: useGoodsCreateSelector, ...GoodsCreateStore } = createStore(reducer);
